import PropTypes from 'prop-types';
import {EntityIllustration} from 'front-onceforall-core';

import {getOrganisationLogoUrl} from '../../../utils/organisation';

const OrganisationItem = props => {
  const {organisation} = props;
  const {address} = organisation;

  function displayCaretRight() {
    if (props.isSuggestion) { return null; }
    return (
      <div className="col-1 d-flex justify-content-end align-items-center">
        <span
          data-id="caret"
          className="caret-right mr-3"
        />
      </div>
    );
  }

  return (
    <div className={`box mt-3 ${!props.isSuggestion ? 'clickable' : ''}`}>
      <div className="row">
        <div className="col-6 flex-container">
          <div className="flex-container column justify-content-center">
            <EntityIllustration
              imageUrl={getOrganisationLogoUrl(organisation.organisationId)}
              country={organisation.country}
              name={organisation.fullName}
              small
            />
          </div>
          <div className="flex-container column justify-content-center">
            <strong data-id="fullName">{organisation.fullName}</strong>
            <span data-id="registrationNumber">{organisation.registrationNumber}</span>
          </div>
        </div>
        <div className="col-5 flex-container column justify-content-center">
          <span data-id="addressLine">{address.addressLine}</span>
          <span data-id="city">{address.postCode} {address.city}</span>
        </div>
        {displayCaretRight()}
      </div>
    </div>
  );
};

OrganisationItem.defaultProps = {
  isSuggestion: false
};

OrganisationItem.propTypes = {
  organisation: PropTypes.object.isRequired,
  isSuggestion: PropTypes.bool
};

export default OrganisationItem;
